<template>
  <div>
    <section class="hero is-info is-bold">
      <div class="hero-body">
          <div class="container">
              <h1 class="title">เปลี่ยนรหัสผ่าน</h1>
              <h2 class="subtitle">SRU Authentication</h2>
          </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <form @submit="onSubmit" method="post" novalidate>
          <b-field label="ชื่อล็อกอิน">
              <b-input type="text" v-model="username" required></b-input>
          </b-field>

          <b-field label="รหัสผ่านเดิม">
            <b-input type="password" v-model="oldpassword" password-reveal required></b-input>
          </b-field>

          <b-field label="รหัสผ่านใหม่">
            <b-input type="password" v-model="newpassword" password-reveal required></b-input>
          </b-field>

          <b-field label="ยืนยันรหัสผ่าน">
            <b-input type="password" v-model="conpassword" password-reveal required></b-input>
          </b-field>

          <div class="buttons">
            <b-button type="is-primary" native-type="submit">ตกลง</b-button>
            <b-button type="is-light" @click="reset">ยกเลิก</b-button>
          </div>
        </form>
      </div>
    </section>
    <b-loading :active.sync="isLoading"></b-loading>
  </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import html2canvas from 'html2canvas'
import { setTimeout, setInterval } from 'timers'
 
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      isLoading: false,
      username: '',
      oldpassword: '',
      newpassword: '',
      conpassword: ''
    }
  },
  mounted() {
    
  },
  methods: {
    onSubmit: function(e) {
      e.preventDefault()

      if(!this.username || !this.oldpassword || !this.newpassword || !this.conpassword) {
        this.$buefy.toast.open({
          message: 'กรุณากรอกข้อมูลให้ครบถ้วน',
          position: 'is-bottom',
          type: 'is-danger'
        })
        return false
      }
      
      this.isLoading = true

      let params = qs.stringify({
        username: this.username,
        old_password: this.oldpassword,
        new_password: this.newpassword,
        confirm_password: this.conpassword
      })

      let that = this
      setTimeout(function() {
        axios.post('http://user.sru.ac.th/change/api.php', params).then(response => {
          if(response.data.status == 'error') {
            for(let i in response.data.messages) {
              that.$buefy.toast.open({
                message: response.data.messages[i],
                position: 'is-bottom',
                type: 'is-danger'
              })
            }
            return false
          }

          that.isLoading = false

          if(response.data.status == 'success') {
            for(let i in response.data.messages) {
              that.$buefy.toast.open({
                message: response.data.messages[i],
                position: 'is-bottom',
                type: 'is-success'
              })
            }

            that.reset()
            return false
          }
        })
      }, 500)
    },

    reset: function() {
      this.isLoading = false
      this.username = null
      this.oldpassword = null
      this.newpassword = null
      this.conpassword = null
    }
  }
}
</script>

<style>

</style>